export default function useSeoHead({ title, description = '', image = '', routePath = '' }) {
  const frontendUrl = process.env.VUE_APP_FRONTEND_URL || '';
  const fullUrl = `${frontendUrl}${routePath}`;
  const fullImage = `${frontendUrl}${image}`;

  return {
    title: () => ({ inner: title }),
    meta: () => [
      {
        name: 'description',
        itemprop: 'description',
        content: description,
        id: 'meta:description',
      },
      {
        itemprop: 'name',
        content: title,
        id: 'meta:name',
      },
      {
        itemprop: 'image',
        content: fullImage,
        id: 'meta:image',
      },
      {
        property: 'og:url',
        content: fullUrl,
        id: 'og:url',
      },
      {
        property: 'og:type',
        content: 'website',
        id: 'og:type',
      },
      {
        property: 'og:title',
        content: title,
        id: 'og:title',
      },
      {
        property: 'og:image',
        content: fullImage,
        id: 'og:image',
      },
      {
        property: 'og:image:alt',
        content: title,
        id: 'og:image:alt',
      },
      {
        property: 'og:description',
        content: description,
        id: 'og:description',
      },
      {
        property: 'og:site_name',
        content: frontendUrl,
        id: 'og:site_name',
      },
      {
        property: 'og:locale',
        content: 'en_US',
        id: 'og:locale',
      },
      {
        name: 'twitter:card',
        content: 'summary',
        id: 'twitter:card',
      },
      {
        name: 'twitter:site',
        content: '@BrowngrottaArts',
        id: 'twitter:site',
      },
      {
        name: 'twitter:creator',
        content: '@BrowngrottaArts',
        id: 'twitter:creator',
      },
      {
        name: 'twitter:url',
        content: fullUrl,
        id: 'twitter:url',
      },
      {
        name: 'twitter:title',
        content: title,
        id: 'twitter:title',
      },
      {
        name: 'twitter:description',
        content: description,
        id: 'twitter:description',
      },
      {
        name: 'twitter:image',
        content: fullImage,
        id: 'twitter:image',
      },
      {
        name: 'twitter:image:alt',
        content: title,
        id: 'twitter:image:alt',
      },
    ],
  };
}
